import React, { FCWithChildren, useContext, useEffect, useState } from 'react';
import {
  SellingOffersProduct,
  SellingOffersProductsItem,
} from '@interfaces/models/negotiation/domain/SellingOffersProduct';
import { scrollToTop } from '@helpers/utils/general';
import { SELLING_OFFERS_PATH } from '@constants/negotiation';
import { useRouter } from 'next/router';

type ListItemDataType = SellingOffersProductsItem;

type ListItemSelectContextProps = {
  selectedListItemId: number | null;
  setSelectedListItemId: React.Dispatch<React.SetStateAction<number | null>>;
  selectedListItemProduct: SellingOffersProduct | null;
  setSelectedListItemProduct: React.Dispatch<React.SetStateAction<SellingOffersProduct | null>>;
  handleItemClick: (id: number) => void;
  listData: ListItemDataType[];
  setListData: React.Dispatch<React.SetStateAction<ListItemDataType[]>>;
  hasNegotiationColumnError: boolean;
  setHasNegotiationColumnError: React.Dispatch<React.SetStateAction<boolean>>;
};

const ListItemSelectContext = React.createContext<ListItemSelectContextProps>({} as ListItemSelectContextProps);
export const useListItemSelectContext = () => useContext(ListItemSelectContext);

export const ListItemSelectContextProvider: FCWithChildren = ({ children }) => {
  const [selectedListItemId, setSelectedListItemId] = useState<number | null>(null);
  const [listData, setListData] = useState<ListItemDataType[]>([]);
  const [selectedListItemProduct, setSelectedListItemProduct] = useState<SellingOffersProduct | null>(null);
  const [hasNegotiationColumnError, setHasNegotiationColumnError] = useState(false);
  const router = useRouter();

  const handleItemClick = (id: number) => {
    router.push(`${SELLING_OFFERS_PATH}${id}`, undefined, { shallow: true });
    setSelectedListItemId(id);
    scrollToTop();
    setHasNegotiationColumnError(false);
  };

  useEffect(() => {
    if (selectedListItemId && listData?.some((item) => item.product.id === selectedListItemId)) {
      const selectedProductItem = listData?.find((item) => item?.product?.id === selectedListItemId);
      setSelectedListItemProduct(selectedProductItem.product);
    }
  }, [selectedListItemId, listData]);

  return (
    <ListItemSelectContext.Provider
      value={{
        selectedListItemId,
        setSelectedListItemId,
        handleItemClick,
        listData,
        setListData,
        selectedListItemProduct,
        setSelectedListItemProduct,
        hasNegotiationColumnError,
        setHasNegotiationColumnError,
      }}
    >
      {children}
    </ListItemSelectContext.Provider>
  );
};
